import { FC, ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type SectionContainerLayoutProps = {
  children: ReactNode;
  className?: string;
  horizontal?: boolean;
};

export const SectionContainerLayout: FC<SectionContainerLayoutProps> = ({
  children,
  className,
  horizontal,
}) => (
  <div
    className={cx(
      'mb-10 flex flex-col gap-6 border-b border-gray-300 pb-10 last:mb-0 last:pb-0',
      horizontal && 'flex-row gap-8',
      className,
    )}
  >
    {children}
  </div>
);
